import { useSelector, useDispatch } from "react-redux";
import { setSelectedDeviceData } from "../pages/AxiosRtk/DashBoard";

export function useDashboardDataProvider() {
    const dispatch = useDispatch();
    const { kidDevicesList } = useSelector(({ dashboard }) => dashboard);

    function handleDeviceSelection(val) {
        if (val.value) {
            const deviceData = kidDevicesList.find((device) => {
                return device?.ID === val.value;
            });

            dispatch(setSelectedDeviceData(deviceData));
        } else {
            dispatch(setSelectedDeviceData(null));
        }
    }

    return {
        handleDeviceSelection
    }
}